import type { RouteObject } from "react-router-dom";

import { path } from "./path";

import { ModalPage } from "@pages/testPage/ModalPage";
import { AlertPage } from "@pages/testPage/AlertPage";
import { DatePickerPage } from "@pages/testPage/DatePickerPage";
import { NotifPage } from "@pages/testPage/NotifPage";
import { SwiperPage } from "@pages/testPage/SwiperPage";
import { TestDynamicPage } from "@/pages/testPage/TestDynamicPage";

// these are exluded from production
export const testRoutes: RouteObject[] = import.meta.env.PROD
  ? []
  : [
      {
        path: path.test1.route,
        // element: <TestPage />
        lazy: () => import("@pages/testPage/TestPage"),
      },
      {
        path: path.test2.route,
        lazy: () => import("@pages/testPage/TestPage2"),
        // async lazy() {
        //   import('@pages/TestPage') // preload other pages
        //   const { Component } = await import('@pages/TestPage2')
        //   return { Component }
        // }
      },
      {
        path: path["test-dynamic"].route,
        element: <TestDynamicPage />,
      },
      // {
      //   path: path.login.route,
      //   lazy: () => import('@pages/testPage/Login'),
      //   loader: loginLoader
      // },
      {
        path: path.modal.route,
        element: <ModalPage />,
      },
      {
        path: path.alert.route,
        element: <AlertPage />,
      },
      {
        path: path["date-picker-page"].route,
        element: <DatePickerPage />,
      },
      {
        path: path?.notif?.route,
        element: <NotifPage />,
      },
      {
        path: path?.swiper?.route,
        element: <SwiperPage />,
      },
    ];
